<template>
	<div class="environment">
		<div class="title">
			<img src="../../../assets/img/logo.png" alt="">
			<span>环境感知</span>
		</div>
		<div class="environmentbox">
			<div class="environment_style" v-for="item,index in box" :key='index'>
			  <span>
				  <div>
					  <img :src="item.img" alt="">
				  </div>
				  <p>{{item.title}}<span>{{item.title1}}</span></p>
				  <p></p>
				  <h5>{{item.title2}}</h5>
			  </span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: "",
	  data() {
	  	return{
			box:[
				{
					img:require('../../../assets/img/huanjin.png'),
					title:'45%',
					title1:'RH',
					title2:'环境湿度'
				},
				{
					img:require('../../../assets/img/kongqi.png'),
					title:'优',
					title1:'',
					title2:'空气质量'
				},
				{
					img:require('../../../assets/img/pm.png'),
					title:'42.7',
					title1:'m³',
					title2:'PM2.5值'
				},
				{
					img:require('../../../assets/img/gaowenyuj.png'),
					title:'24.5',
					title1:'℃',
					title2:'高温预警'
				},
				]
		}
	  },
	  methods: {
	  },
	  mounted() {
	  }
	};
</script>

<style scoped="scoped">
	.environment{
		width: 100%;
		height: 25%;
	}
	.environmentbox{
		width: 100%;
		height: calc(100% - 4vh);
		display: flex;
		justify-content:space-between;
		align-items: center;
		
	}
	.environment_style{
		width: 24%;
		height: 76%;
		display: flex;
		align-items: center;
		text-align: center;
		justify-content:center;
		background: url(../../../assets/img/environment.png) no-repeat;
		background-size: 100% 100%;
	}
	.environment_style>span{
		display: inline-block;
	}
	.environment_style>span>div{
		width: 2vw;
		height: 2vw;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content:center;
	}
	.environment_style>span>div>img{
		
	}
	.environment_style>span>p:nth-of-type(1){
		font-size: 1vw;
		font-weight: 400;
		color: #1F9ECC;
	}
	.environment_style>span>p:nth-of-type(1)>span{
		color: #FFFFFF;
	}
	.environment_style>span>p:nth-of-type(2){
		height: .2vh;
		width: 80%;
		margin: 8px auto;
		background: rgb(152, 161, 173);
	}
	.environment_style>span>h5{
		font-size: .8vw;
		font-family: 'uirl';
		font-weight: 400;
		color: #FFFFFF;
	}
</style>
